// extracted by mini-css-extract-plugin
export default {"button":"styles_button__sRzXH","button-text":"styles_button-text__o4JKA","ant-btn-disabled":"styles_ant-btn-disabled__j612p"};